import { useState } from "react";
import { callFunction } from "../lib/api";
import { supabase } from "../lib/supabase";

export const useDeleteAccount = () => {
  const [loading, setLoading] = useState(false);

  const deleteAccount = async () => {
    try {
      setLoading(true);

      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session) {
        throw new Error("No session found");
      }

      await callFunction("/delete-account", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        },
      });

      await supabase.auth.signOut();
      return true;
    } finally {
      setLoading(false);
    }
  };

  return {
    deleteAccount,
    loading,
  };
};
